import * as React from 'react';
import { useViewTrackerContext } from 'src/common/stores/contexts/viewTracker';
import { boolean, object, optional, safeParse } from 'valibot';
import { useClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { ViewLarge, Viewport } from '@shared-ui/viewport-context';
import { Sidebar } from 'components/search/sidebar';
export const SidebarWrapper = ({
  templateComponent
}) => {
  var _a;
  const viewTracker = useViewTrackerContext();
  const tracker = useClickstreamAnalytics();
  const configSchema = optional(object({
    bexQuickFiltersEnabled: optional(boolean())
  }));
  const result = safeParse(configSchema, templateComponent.config);
  if (!result.success) {
    return null;
  }
  const {
    bexQuickFiltersEnabled
  } = (_a = result.output) !== null && _a !== void 0 ? _a : {};
  return React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(Sidebar, {
    tracker: tracker,
    viewTracker: viewTracker,
    bexQuickFiltersEnabled: bexQuickFiltersEnabled
  })));
};